import { createContext, useContext } from 'react';

/**
 * Whether the pages are laid out by the new shell, for anything that has to
 * change behaviour with it but is too far from the shell to fetch it.
 *
 * This is `studio-tree-insights`, the revamp's master switch. The shell is what
 * makes those surfaces usable, so it rides the same flag rather than owning one
 * of its own.
 *
 * It does NOT decide whether the chat has a column to dock into: that is
 * `PanelHostContext`, on the AI flag, so the assistant can ship to a tenant that
 * is not on the revamp. Read this one for anything about the width a page was
 * given; read that one for anything about the panel.
 *
 * `false` by default, which is also what a component outside the provider sees.
 * Fail-closed reads the same here as everywhere else on this flag: not knowing
 * means render what the product does today.
 *
 * The shell resolves the flag once and publishes it. Components asking the
 * endpoint for themselves would each spend a request, and worse, would flip at
 * different moments, so parts of one page would be laid out to the new rules
 * while the rest were still on the old ones.
 */
export const ResponsiveLayoutContext = createContext<boolean>(false);

export function useResponsiveLayout(): boolean {
  return useContext(ResponsiveLayoutContext);
}
